import { connect } from 'react-redux';

import { Creators as applicationActions } from 'Reducers/application';

import DonorResultNotSaved from './view';

// token is already expired, so no logout call
export default connect(null, {
  clearSession: applicationActions.clearSession
})(DonorResultNotSaved);
